import type { UseFormReturn } from "react-hook-form";
import { FormControl, FormField, FormItem, FormLabel, FormMessage, Textarea } from "@/components/ui";
import { RepairIntakeRadioField } from "@/pages/public/repairIntakeForm/RepairIntakeRadioField";
import type { RepairIntakeFormData } from "@/store/useRepairIntakeStore";

type RepairIntakeSection6Props = {
  form: UseFormReturn<RepairIntakeFormData>;
  activeLeak: RepairIntakeFormData["section6"]["activeLeak"];
};

export function RepairIntakeSection6({ form, activeLeak }: RepairIntakeSection6Props) {
  return (
    <>
      <RepairIntakeRadioField form={form} name="section6.activeLeak" label="1. Is there an active leak? *" />

      {activeLeak === "Yes" ? (
        <>
          <FormField
            control={form.control}
            name="section6.leakMitigationPlan"
            render={({ field }) => (
              <FormItem>
                <FormLabel>2. If leaking, what is the leak mitigation plan? *</FormLabel>
                <FormControl>
                  <Textarea {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="section6.clientLeakStopPlan"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  3. If client is mitigating leak, what is their plan to stop the leak and what was the original defect?
                  *
                </FormLabel>
                <FormControl>
                  <Textarea {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </>
      ) : null}
    </>
  );
}
